module.exports = __webpack_public_path__ + "static/media/fondo_rocas.21082a37.jpg";